import * as React from 'react';

const FinishEmailLogin = React.lazy(() => import('./container'));

export default () => <FinishEmailLogin />;
